import { IS_SMALL_SCREEN } from '@Constants/LeftDrawer';
import useCheckoutPresenter from '@Screens/Checkout/presenter';
import { utilStyles } from '@Utils/utilStyles';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React, { useEffect } from 'react';
import { StyleSheet, TextStyle } from 'react-native';
import styled from 'styled-components/native';

import { PrimaryButton } from '../../../Common/PrimaryButton';
import { useCheckoutContextState } from '../CheckoutContextState';

import { useCheckoutStore } from '~stores/checkout';
import OwnableTheme from '@Theme';
import { buttonLabelStyles } from '../utils';

const StyledContainer = styled.View`
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledButtonContainer = styled.View`
  margin: 10px 0;
`;

const GuestOrLoginStep: FC<object> = () => {
  const {
    setCurrentCheckoutAvailableFeatures,
    _onUserChooseToLoginButton,
    showIdentityStep,
  } = useCheckoutStore();

  const { handleCancelCheckoutFlow, orderDetailsVisible } =
    useCheckoutPresenter();

  const { onCancelButton } = useCheckoutContextState();

  const { guestOrLoginPromptVisible } = useCheckoutContextState();
  useEffect(
    () => () => {
      guestOrLoginPromptVisible.set(false);
    },
    []
  );

  useEffect(() => {
    guestOrLoginPromptVisible.set(showIdentityStep);
  }, [showIdentityStep]);

  const fontSize = IS_SMALL_SCREEN ? 14 : 18;
  return (
    <StyledContainer>
      {showIdentityStep && (
        <StyledButtonContainer>
          <PrimaryButton
            text='Continue as guest'
            color='black'
            textColor='white'
            styleOverride={styles.disableBackButtonOverride}
            width='100%'
            fontStyleOverride={[
              { fontSize },
              utilStyles.textAlignCenter,
              buttonLabelStyles,
            ]}
            onPress={() => {
              orderDetailsVisible.set(true);
              setCurrentCheckoutAvailableFeatures([
                'CollectGuestName',
                'CollectGuestEmail',
                'ConfirmGuestDetailsButton',
                'ShowOrderInfo',
                'CollectDeliveryAddress',
                'CollectPaymentAddress',
                'ChangeItemQuantity',
                'CollectPaymentCardDetails',
                'ConfirmOrderButton',
              ]);
            }}
          />
          <StyledButtonContainer>
            <PrimaryButton
              text='Use my Ownable account'
              color='black'
              textColor='white'
              styleOverride={styles.isSmallScreen}
              width='100%'
              fontStyleOverride={[
                { fontSize },
                utilStyles.textAlignCenter,
                buttonLabelStyles,
              ]}
              onPress={() => {
                _onUserChooseToLoginButton().then();
              }}
            />
          </StyledButtonContainer>
          <StyledButtonContainer>
            <PrimaryButton
              text='Cancel'
              color='white'
              textColor='black'
              borderColor='black'
              onPress={() => {
                orderDetailsVisible.set(false);
                onCancelButton();
                handleCancelCheckoutFlow();
              }}
              styleOverride={styles.isSmallScreen}
              width='100%'
              fontStyleOverride={[
                { fontSize },
                utilStyles.textAlignCenter,
                buttonLabelStyles,
              ]}
            />
          </StyledButtonContainer>
        </StyledButtonContainer>
      )}
    </StyledContainer>
  );
};

export default observer(GuestOrLoginStep);

const styles = StyleSheet.create({
  disableBackButtonOverride: {
    marginBottom: 5,
    height: IS_SMALL_SCREEN ? 40 : 50,
  },
  isSmallScreen: {
    height: IS_SMALL_SCREEN ? 40 : 50,
  },
});
